import React, { useState } from 'react';

// Utils
import { isNil } from 'lodash';
import { useMediaQuery } from 'react-responsive';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import adminTypes from '../../../../constants/adminTypes';
import PermissionsGate from '../../../../utils/gate/permissionsGate';
import SCOPE from '../../../../utils/gate/scope';

// Icons
import { ReactComponent as EditIcon } from '../../../../assets/icons/edit.svg';

// Services
import useAdministratorsService from '../../../../services/administratorsService';
import useRolesService from '../../../../services/rolesService';

// Components
import AdministrationTable from '../../../tables/AdministrationTable/AdministrationTable';
import AccountCreation from '../../../tables/AdministrationTable/AccountCreation/AccountCreation';
import Button from '../../../atoms/Button/Button';

function Administration() {
  const { t } = useTranslation();
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const [roles, setRoles] = useState(null);
  const [administrators, setAdministrators] = useState(null);

  const { getEstablishmentRoles } = useRolesService();
  const { getEstablishmentAdministrators } = useAdministratorsService();

  const { isFetching: isFetchingRoles } = useQuery(['getEstablishmentRoles'], () => getEstablishmentRoles(), {
    onSuccess: (res) => setRoles(res?.data?.establishmentRoles || []),
  });

  const { isFetching: isFetchingAdmins } = useQuery(
    ['getEstablishmentAdministrators', roles],
    () => getEstablishmentAdministrators(),
    {
      enabled: !isNil(roles),
      onSuccess: (res) => setAdministrators(res?.data?.accounts || []),
    },
  );

  return (
    <>
      {!isMobile && !isFetchingAdmins && !isFetchingRoles ? (
        <div className="d-flex j-end f-wrap m-b-10">
          <a
            href="/roles"
            className="d-flex a-center c-primary-500 fs-16 font-secondary fw-600 c-pointer m-l-auto m-t-15 p-l-20"
          >
            <EditIcon className="m-r-10" />
            {t('roles.title')}
          </a>
        </div>
      ) : null}

      <AdministrationTable
        tableType={adminTypes.establishment}
        roles={roles}
        administrators={administrators}
        setAdministrators={setAdministrators}
        isFetching={isFetchingAdmins || isFetchingRoles}
      />

      {!isFetchingRoles && !isFetchingAdmins ? (
        <div className="d-flex a-center j-end sticky-actions mobile-a-stretch">
          {isMobile ? (
            <a href="/roles" className="m-b-10">
              <Button full theme="inverted-white">
                <EditIcon className="m-r-10" />
                {t('roles.title')}
              </Button>
            </a>
          ) : null}

          <PermissionsGate scopes={[SCOPE.create_ownEst_adminAccount]}>
            <AccountCreation
              tableType={adminTypes.establishment}
              roles={roles}
              setAdministrators={setAdministrators}
            />
          </PermissionsGate>
        </div>
      ) : null}
    </>
  );
}

Administration.propTypes = {};

export default Administration;
